import { Inject, Injectable, Injector } from '@angular/core';
import { BaseService } from '../base.service';
import { IAppConfig } from '../Config/app-config.model';
import { PublicationModel } from 'src/app/shared/model/publication.model';
import { Observable, of } from 'rxjs';
import { PublishingListItem } from '../publishing/PagedPublishingList';
import { observableToBeFn } from 'rxjs/internal/testing/TestScheduler';

@Injectable({
  providedIn: 'root'
})
export class PublicationService extends BaseService {
  publicationYear: string;
  publicationDate: PublishingListItem;

  constructor(public _injector: Injector, @Inject('appconfig') private configParam: IAppConfig) {
    super(_injector);
  }

  getPublicationYears() {
    return this.Get<string[]>(`${this.configParam.ApiConfig.API_ENDPOINT}Publication/PublicationYears`);
  }

  getPublication(publishingId: string): Observable<PublicationModel> {
    return this.Get<PublicationModel>(`${this.configParam.ApiConfig.API_ENDPOINT}Publication/${publishingId}`);
  }

  setPublicationYear(year: string) {
    this.publicationYear = year;
  }

  setPublicationDate(date: PublishingListItem) {
    this.publicationDate = date;
  }

  getPublicationYear() {   
    if (this.publicationYear == undefined) return undefined;
    return this.publicationYear;
  }

  getPublicationDate() {
    if (this.publicationDate == undefined) return undefined;    
    return this.publicationDate;
  }
}
